<template>
    <div class="row">
        <div class="col-12 px-0">
            <nav v-if="mode === 'arrowcrumb'" aria-label="breadcrumb" class="arrowcrumb" :class="{'mobile-view': isMobileView}">
                <ul class="breadcrumb p-0 m-0">
                    <template v-for="(crumb, index) in crumbsToRender" >
                        <router-link v-if="crumb.is_active" :tag="'a'" :class="['breadcrumb-item px-0',{'breadcrumb-item--is-complete': crumb.is_complete}]" active-class="breadcrumb-active"
                                     :to="getUrl(crumb)">
                            <p>
                                <span class="breadcrumb-step">{{lang('step')}} {{index + 1}}</span>
                                <span class="breadcrumb-label">{{getLabel(crumb.label)}}</span>
                                <span class="breadcrumb-short-label"> {{getLabel(crumb.short_label)}}</span>
                            </p>
    <!--                        <p> {{lang('step')}} {{index + 1}} <br>-->
    <!--                            {{ !isMobileView ? getLabel(crumb.label) : getLabel(crumb.short_label)}}-->
    <!--                        </p>-->
                            <!--                        <p v-else> {{lang('step')}} {{index + 1}} <br> {{getLabel(crumb.short_label)}}</p>-->
                        </router-link>
                        <a  v-else class="breadcrumb-item px-0 disabled-link" :key="index" @click="preventNavigation"
                           href="" >
                            <p>
                                <span class="breadcrumb-step">{{lang('step')}} {{index + 1}}</span>
                                <span class="breadcrumb-label">{{getLabel(crumb.label)}}</span>
                                <span class="breadcrumb-short-label"> {{getLabel(crumb.short_label)}}</span>
                            </p>
                        </a>
                    </template>

                </ul>
            </nav>
<!--            doesn't need a mobile view-->
            <nav v-else-if="mode === 'pagecrumb'" aria-label="breadcrumb" class="pagecrumb">
                <ol class="breadcrumb bg-none">
                    <li v-for="(crumb, index) in crumbsToRender" class="breadcrumb-item">
<!--                        <span v-if="isActive(index)">{{crumb.label}}</span>-->
                        <router-link v-if="crumb.is_active" :tag="'a'" :to="getUrl(crumb)">{{getLabel(crumb.label)}}</router-link>
                        <a href="" class="disabled-link" @click="preventNavigation" v-else>{{getLabel(crumb.label)}}</a>
                        <!--                        <a v-else :href="getUrl(crumb)">{{crumb.label}}</a>-->
                    </li>
                </ol>
            </nav>
        </div>
<!--        {{windowWidth}}-->
<!--     TODO   at about  500px switch the design to pills or something-->
    </div>
</template>

<script>
    export default {
        name: "np-application-breadcrumb",
        data () {
            return {
                isMobileView: window.innerWidth < 768,
                windowWidth: 0
            }
        },
        props: {
            title: {
                type: String,
                default : '',
            },
            mode: '', //pagecrumb ( arrow in-between), arrowcrumb (big_arrow),
            crumbs: {
                type: Array,
                default: () => {
                    return []
                },
            },

        },
        created() {
            this.resizeBreadcrumb();
            window.addEventListener("resize", this.resizeBreadcrumb);
        },
        destroyed() {
            window.removeEventListener("resize", this.resizeBreadcrumb);
        },
        computed: {
            crumbsToRender: function (){
                let tabs = [];
                this.crumbs.forEach( obj => {
                    if(obj.display){
                        tabs.push(obj)
                    }
                });
                return tabs;
            }
        },
        mounted() {
            // window.onresize = this.resizeBreadcrumb()
        },
        methods: {
            preventNavigation:function($event) {
                $event.preventDefault()
            },
            getUrl: function (crumb){
                return !!crumb.url ? crumb.url : '#';
            },
            getLabel: function (label){
              return !!label ? this.lang(label) : '';
            },
            isActive: function(index) {
                return index + 1 === this.crumbsToRender.length //last index is inactive.
            },
            select: function(name, index) {
                //this.activeIndex = index;
                this.$emit('update:active-index', index);
            },
            resizeBreadcrumb: function () {
                // //console.log(window.innerWidth);
                this.windowWidth = window.innerWidth;
                this.isMobileView = window.innerWidth < 768;
            }
        },
    }
</script>

<style scoped>
    ul.nav.nav-pills{
        font-size: 16px;
    }
    .disabled-link {
        cursor: not-allowed;
    }

    /*.arrowcrumb .breadcrumb-item.breadcrumb-item--is-complete:not(.breadcrumb-active) {*/
    /*    color: #fff;*/
    /*    background-color: #263d88;*/
    /*}*/

    /*.arrowcrumb .breadcrumb-item.breadcrumb-item--is-complete:not(.breadcrumb-active)::after {*/
    /*    color: #fff;*/
    /*    border-left-color: #263d88;*/
    /*}*/

    /*!*.arrowcrumb .breadcrumb-item.breadcrumb-item--is-complete::after {*!*/
    /*!*    border-left: 30px solid inherit !important;*!*/
    /*!*}*!*/

    .arrowcrumb .breadcrumb-item.disabled-link {
        color: #999;
    }

    .arrowcrumb .breadcrumb-item.disabled-link:hover {
        background-color: inherit;
        color: #999;
    }

    .arrowcrumb .breadcrumb-item.disabled-link::after {
        border-left: 30px solid inherit !important;
    }
</style>